module.exports = __webpack_public_path__ + "img/icon_yaunxiao.807d6ac2.svg";